import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Icon,
  FormGroup,
  FormField,
  Button,
  Input,
  Checkbox,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardDivisionSearchUX = (props: any) => {
    return(
      <div>
        <div
          className="ui accordion blue  fluid raised segment"
          id="CardDivisionSearchUX-div-1"
          style={{boxShadow: "none"}}>
          
          <div
            id="CardDivisionSearchUX-div-2"
            style={{display: "flex", justifyContent: "space-between"}}>
            
            <label
              id="CardDivisionSearchUX-label-3"
              style={{fontSize: "1.2rem", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Find an agency" : "ค้นหาหน่วยงาน"}
            </label>
            <div
              id="CardDivisionSearchUX-div-4"
              style={{cursor: "pointer"}}>
              
              <Icon
                className="red large"
                id="CardDivisionSearchUX-Icon-5"
                name={"close"}
                onClick={props.onClose}>
              </Icon>
            </div>
          </div>
          <div
            className="ui divider"
            id="CardDivisionSearchUX-div-6">
            
          </div>
          <div
            className="ui form"
            id="CardDivisionSearchUX-div-7">
            
            <FormGroup
              id="CardDivisionSearchUX-FormGroup-8"
              inline={true}>
              <FormField
                id="CardDivisionSearchUX-FormField-10"
                inline={true}
                width={1}>
              </FormField>
              <FormField
                id="CardDivisionSearchUX-FormField-11"
                inline={true}
                width={2}>
                <label
                  id="CardDivisionSearchUX-label-38"
                  style={{textAlign: "right", width: "100%"}}>
                  {props.languageUX === "en" ? "code" : "รหัส"}
                </label>
              </FormField>
              <FormField
                id="CardDivisionSearchUX-FormField-12"
                inline={true}
                width={4}>
                <Input
                  id="CardDivisionSearchUX-Input-39"
                  onChange={props.onChangeCode}
                  value={props.codeContains}>
                </Input>
              </FormField>
              <FormField
                id="CardDivisionSearchUX-FormField-13"
                inline={true}
                width={1}>
                <label
                  id="CardDivisionSearchUX-label-40"
                  style={{textAlign: "right", width: "100%"}}>
                  {props.languageUX === "en" ? "name" : "ชื่อ"}
                </label>
              </FormField>
              <FormField
                id="CardDivisionSearchUX-FormField-14"
                inline={true}
                width={6}>
                <Input
                  id="CardDivisionSearchUX-Input-41"
                  onChange={props.onChangeName}
                  value={props.name}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardDivisionSearchUX-FormGroup-9"
              inline={true}>
              <FormField
                id="CardDivisionSearchUX-FormField-20"
                inline={true}
                width={1}>
              </FormField>
              <FormField
                id="CardDivisionSearchUX-FormField-21"
                inline={true}
                width={2}>
                <Checkbox
                  checked={props.checkedType}
                  id="CardDivisionSearchUX-Checkbox-43"
                  label={props.languageUX === "en" ? "type" : "ประเภท"}
                  onChange={props.onCheckedType}
                  style={{fontWeight: "bold"}}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardDivisionSearchUX-FormField-22"
                inline={true}
                width={4}>
                <Dropdown
                  fluid={true}
                  id="CardDivisionSearchUX-Dropdown-44"
                  onChange={props.handleChangeType}
                  options={props.divisionTypeOptions}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.type}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardDivisionSearchUX-FormField-23"
                inline={true}
                width={1}>
              </FormField>
              <FormField
                id="CardDivisionSearchUX-FormField-24"
                inline={true}
                width={2}>
                <Button
                  color={"blue"}
                  fluid={true}
                  id="CardDivisionSearchUX-Button-29"
                  onClick={props.onSearch}>
                  {props.languageUX === "en" ? "Search" : "ค้นหา"}
                </Button>
              </FormField>
              <FormField
                id="CardDivisionSearchUX-FormField-42"
                inline={true}
                width={2}>
                <Button
                  color={"teal"}
                  fluid={true}
                  id="CardDivisionSearchUX-Button-45"
                  onClick={props.onClear}>
                  {props.languageUX === "en" ? "clear" : "ล้างหน้าจอ"}
                </Button>
              </FormField>
            </FormGroup>
            <div
              id="CardDivisionSearchUX-div-32"
              style={{marginBottom: "1rem"}}>
              
              <Table
                data={props.divisionList}
                getTrProps={props.onGetTrProps}
                headers="Code,ชื่อ (ไทย),ชื่อ (อังกฤษ),ประเภท"
                id="CardDivisionSearchUX-Table-33"
                keys="code,name,name_en,type_label"
                showPagination={false}
                style={{width: "100%",  height: "400px"}}>
              </Table>
            </div>
            <FormGroup
              id="CardDivisionSearchUX-FormGroup-34">
              <FormField
                id="CardDivisionSearchUX-FormField-36"
                inline={true}
                width={2}>
                <Button
                  color={"blue"}
                  fluid={true}
                  id="CardDivisionSearchUX-Button-37"
                  onClick={props.onSelect}>
                  {props.languageUX === "en" ? "choose" : "เลือก"}
                </Button>
              </FormField>
            </FormGroup>
          </div>
        </div>
      </div>
    )
}


export default CardDivisionSearchUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:44:09 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui accordion blue  fluid raised segment"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{boxShadow: \"none\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาหน่วยงาน",
          "valueEN": "Find an agency"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-label-3"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Icon",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-Icon-5"
        },
        "name": {
          "type": "code",
          "value": "\"close\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-div-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormGroup-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormGroup-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Button",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "code",
          "value": "\"blue\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-Button-29"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearch"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-div-32"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"1rem\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 33,
      "name": "Table",
      "parent": 32,
      "props": {
        "data": {
          "type": "code",
          "value": "props.divisionList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onGetTrProps"
        },
        "headers": {
          "type": "value",
          "value": "Code,ชื่อ (ไทย),ชื่อ (อังกฤษ),ประเภท"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-Table-33"
        },
        "keys": {
          "type": "value",
          "value": "code,name,name_en,type_label"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",  height: \"400px\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormGroup-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Button",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก",
          "valueEN": "choose"
        },
        "color": {
          "type": "code",
          "value": "\"blue\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-Button-37"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelect"
        },
        "size": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัส",
          "valueEN": "code"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\", width: \"100%\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Input",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-Input-39"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCode"
        },
        "value": {
          "type": "code",
          "value": "props.codeContains"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ",
          "valueEN": "name"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-label-40"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\", width: \"100%\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "Input",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-Input-41"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeName"
        },
        "value": {
          "type": "code",
          "value": "props.name"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Checkbox",
      "parent": 21,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedType"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-Checkbox-43"
        },
        "label": {
          "type": "value",
          "value": "ประเภท",
          "valueEN": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onCheckedType"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Dropdown",
      "parent": 22,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-Dropdown-44"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeType"
        },
        "options": {
          "type": "code",
          "value": "props.divisionTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.type"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "Button",
      "parent": 42,
      "props": {
        "basic": {
          "type": "code",
          "value": ""
        },
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "clear"
        },
        "color": {
          "type": "code",
          "value": "\"teal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionSearchUX-Button-45"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        }
      },
      "seq": 45,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 70,
  "isMounted": false,
  "memo": false,
  "name": "CardDivisionSearchUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 65
}

*********************************************************************************** */
